<template>
  <div style="width: 100%">
    <Header4 color="error">Es gab Fehler beim Ändern des Feldtyps:</Header4>
    <i style="font-size: 14px">Behebe die Fehler und versuche es erneut.</i>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Profil</th>
            <th>Fehlermeldung</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="error in updateErrors"
            :key="error.attributable + error.error"
          >
            <td>
              {{ error.name }} (<b>ID:{{ error.attributable.split("#")[1] }}</b
              >)
            </td>
            <td>{{ error.error }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import Header4 from "app/ui-primitives/header/Header4.vue"
import { CustomAttributeDefinitionUpdateError } from "app/modules/custom-attributes/client"

export default defineComponent({
  name: "CustomAttributesUpdateErrors",
  components: { Header4 },
  props: {
    updateErrors: {
      type: Array as PropType<CustomAttributeDefinitionUpdateError[]>,
      required: true,
    },
  },
})
</script>
